import { useEffect, useState } from "react";
import { componentState } from "../../../atoms/componentState";
import { useNavigate } from "react-router-dom";
import { basicInfo, statusInfo } from "../../../interfaces/defaultInterfaces";
import {
  Box,
  Button,
  Flex,
  Icon,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Select,
  Spinner,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
} from "@chakra-ui/react";
import {
  FaArrowRight,
  FaEye,
  FaPlay,
  FaPlus,
  FaTrash,
  FaListUl,
} from "react-icons/fa";
import Pagination from "../../../defaultComponents/pagination";
import { FiLink } from "react-icons/fi";
import {
  VendaDigitada,
  ItensVendadigitada,
} from "../../../interfaces/comercialInterfaces";
import { dateForListWithHours } from "../../../constants/dataFormat";
import moment from "moment";
import { HamburgerIcon } from "@chakra-ui/icons";
import { refreshGlobal } from "../../../atoms/refreshGlobal";
import { DEPLOY_URL } from "../../../services/api";
import {
  goToAddPixDireto,
  goToAddVendaDigitada,
  goToAddVendaDigitadaCartao,
} from "../../../routes/coordinator";
import { JWTToken } from "../../../routes/privateRoute";
import jwt_decode from "jwt-decode";
import VendasDigitadasApi from "../../../services/vendasDigitadasApi";
import { toast } from "react-toastify";
import { permissions } from "../../../atoms/permissions";
import {
  CaptionFormater,
  ToLocaleFormat,
} from "../../../defaultFunctions/formaters";
import { useSetRecoilState, useRecoilState } from "recoil";
import ModalRevisaoPixDireto from "./components/ModalRevisaoPixDireto";
import {
  BLUEMONEDDBUTTONS,
  ORANGEMONEDD,
  VARIANT,
  WHITE,
} from "../../../constants/colors";
import { LoggedUser } from "../../../atoms/userLogged";
import { selectedClientHeader } from "../../../atoms/selectedClientHeader";
import DeletePixDireto from "./components/deletePixDireto";
import DetailsPixDireto from "./components/detailsPixDireto";
import ModalItensVendaDigitada from "../../../defaultComponents/ModalItensVendaDigitada";
export default function VendasPixDireto() {
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [pages, setPages] = useState(1);
  const [loading, setLoading] = useState(false);
  // const [cliente, setCliente] = useState(0);
  const [idDelete, setIdDelete] = useState(0);
  const [listaVendaDigitada, setListaVendaDigitada] = useState(
    Array<VendaDigitada>
  );
  const [openItens, setOpenItens] = useState(false);
  const [itensSelecionados, setItensSelecionados] = useState<
    ItensVendadigitada[]
  >([]);
  const [isOpen, setIsOpen] = useState(false);
  const initialValues = {
    clientFilter: 0,
    statusFilter: 0,
    saleTypeFilter: 0,
    initialDateFilter: "",
    finalDateFilter: "",
    minValueFilter: 0,
    maxValueFilter: 0,
  };
  const [filtros, setFiltros] = useState(initialValues);
  const navigate = useNavigate();
  // const dataInicio = filtros.initialDateFilter;
  // const dataFim = filtros.finalDateFilter;

  const token = window.localStorage.getItem("token");

  let jwtToken: JWTToken = jwt_decode(token || "");
  const user = useRecoilState(LoggedUser)[0];
  const selectedId = useRecoilState(selectedClientHeader)[0];
  const cliente =
    user.idLoginTipo === 4 ? Number(jwtToken.idCliente) : Number(selectedId);

  const perms = useRecoilState(permissions)[0];

  const onChangeSize = (e: any) => {
    setPageSize(e.target.value);
    setCurrentPage(1);
  };
  useEffect(() => {
    if (currentPage > pages) {
      setCurrentPage(1);
    }
  }, [pages]);
  useEffect(() => {}, [
    search,
    currentPage,
    pageSize,
    filtros.statusFilter,
    filtros.saleTypeFilter,
    filtros.clientFilter,
    filtros.initialDateFilter,
    filtros.finalDateFilter,
    filtros.minValueFilter,
    filtros.maxValueFilter,
  ]);
  const setHeaderLocation = useSetRecoilState(componentState);
  useEffect(() => {
    setHeaderLocation("Vendas Digitadas");
  }, []);
  const [statusList, setStatusList] = useState(Array<statusInfo>);
  const [modoPgtoList, setmodoPgtoList] = useState(Array<basicInfo>);

  async function getLista() {
    try {
      setLoading(true);
      const response = await VendasDigitadasApi.getListaVendasDigitadas(
        currentPage,
        pageSize,
        "",
        cliente,
        true
      );
      console.log("response", response);
      setPages(
        Math.ceil(Number(response.headers.totalamountofrecords) / pageSize)
      );
      setListaVendaDigitada(response.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  }
  useEffect(() => {
    getLista();
  }, [pageSize, cliente, currentPage, refreshGlobal]);

  const [openView, setOpenView] = useState(false);
  const [itemView, setItemView] = useState<any>();

  async function sendEmail(token: string) {
    try {
      const response = await VendasDigitadasApi.senEmailWithLinkForPayment(
        token
      );
      toast.success("Link enviado para o e-mail com sucesso!");
    } catch (error) {
      console.log("error: ", error);
      toast.error("Não foi possível enviar o e-mail de pagamento!");
    }
  }

  return (
    <>
      <Flex
        // width={"100%"}
        height={"fit-content"}
        mt={"0.1%"}
        mx="auto"
        py={3}
        bgColor={WHITE}
        px={10}
        shadow={"lg"}
        flexDirection={"column"}
      >
        <Box
          mb={"10px"}
          // width={"100%"}
          height={"fit-content"}
        >
          <Flex alignItems="center">
            <FaPlay color={BLUEMONEDDBUTTONS} size="25px" />
            <Text
              mx={4}
              color={BLUEMONEDDBUTTONS}
              fontSize={35}
              fontWeight={"bold"}
            >
              Venda Pix Direto
            </Text>
          </Flex>
        </Box>

        <Flex
          width={"100%"}
          // height={"100%"}
          justifyContent="flex-start"
          my={"20px"}
          // mr={"50px"}
        >
          {/* <Button
            bgColor={BLUEMONEDDBUTTONS}
            color={WHITE}
            fontSize={"1.8vh"}
            onClick={() => {
              goToAddPixDireto(navigate);
            }}
            mr={"10px"}
            fontWeight={"bold"}
            // isDisabled={
            //   perms &&
            //     perms.findIndex(
            //       (perm: any) =>
            //         perm.idPermissoes === 1 ||
            //         perm.idPermissoes === 25 ||
            //         perm.idPermissoes === 23
            //     ) !== -1
            //     ? false
            //     : true
            // }
          >
            <Icon mr={2} as={FaPlus} />
            NOVA VENDA PIX DIRETO
          </Button> */}
          {/* <Button
            bgColor={BLUEMONEDDBUTTONS}
            color={WHITE}
            fontSize={"1.8vh"}
            onClick={() => {
              goToAddVendaDigitadaCartao(navigate);
            }}
            fontWeight={"bold"}
            isDisabled={
              perms &&
              perms.findIndex((perm: any) => perm.idPermissoes === 27) !== -1
                ? false
                : true
            }
            // isDisabled={false}
          >
            <Icon mr={2} as={FaPlus} />
            NOVA VENDA DIGITADA CARTÃO
          </Button> */}
        </Flex>
      </Flex>
      {loading ? (
        <Flex
          width={"100%"}
          height={"73vh"}
          mt={3}
          mx="auto"
          py={3}
          bgColor={WHITE}
          px={8}
          shadow={"lg"}
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
          // overflowY={"scroll"}
        >
          <Spinner size={"lg"} color={VARIANT} />
        </Flex>
      ) : (
        <Flex
          width={"100%"}
          height={"73vh"}
          mt={3}
          mx="auto"
          py={3}
          bgColor={WHITE}
          px={8}
          shadow={"lg"}
          flexDirection={"column"}
          overflowY={"scroll"}
        >
          <TableContainer>
            <Table variant={"striped"}>
              <Thead h="60px" top="0" zIndex={99999}>
                <Tr>
                  <Th
                    w={"300px"}
                    borderRadius={"8px 0 0 8px"}
                    textAlign={"center"}
                    bgColor={BLUEMONEDDBUTTONS}
                    color={WHITE}
                  >
                    Data de Envio
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={BLUEMONEDDBUTTONS}
                    color={WHITE}
                  >
                    Cliente
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={BLUEMONEDDBUTTONS}
                    color={WHITE}
                  >
                    E-mail
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={BLUEMONEDDBUTTONS}
                    color={WHITE}
                  >
                    ID da transição
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={BLUEMONEDDBUTTONS}
                    color={WHITE}
                  >
                    Valor
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={BLUEMONEDDBUTTONS}
                    color={WHITE}
                  >
                    Status
                  </Th>
                  <Th
                    w={"300px"}
                    borderRadius={"0 8px 8px 0"}
                    textAlign={"center"}
                    bgColor={BLUEMONEDDBUTTONS}
                    color={WHITE}
                  >
                    Opções
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {listaVendaDigitada &&
                  listaVendaDigitada.map((item, index) => {
                    return (
                      <Tr key={index}>
                        <Td
                          textAlign={"center"}
                          borderRadius={"8px 0px 0px 8px"}
                        >
                          {moment(item.atualizadoEm).format(
                            dateForListWithHours
                          )}
                        </Td>
                        <Td textAlign={"center"}>
                          {CaptionFormater(item.nomePagador)}
                        </Td>
                        <Td textAlign={"center"}>{item.emailPagador}</Td>
                        <Td textAlign={"center"}>{item.idTransacaoProvider}</Td>
                        <Td textAlign={"center"}>
                          {ToLocaleFormat(item.valorTotal)}
                        </Td>
                        <Td textAlign={"center"}>
                          <Tooltip
                            label={
                              item.historico[item.historico.length - 1].status
                            }
                            hasArrow
                            bg={ORANGEMONEDD}
                            color="white"
                            placement="auto-start"
                          >
                            {CaptionFormater(item.status)}
                          </Tooltip>
                        </Td>
                        <Td textAlign={"center"} borderRadius={"0 8px 8px 0"}>
                          <Menu>
                            <MenuButton
                              as={IconButton}
                              aria-label="Options"
                              icon={<HamburgerIcon />}
                              bgColor={BLUEMONEDDBUTTONS}
                              color={WHITE}
                              size={"sm"}
                            />
                            <MenuList>
                              <MenuItem
                                as={"a"}
                                target={"_blank"}
                                href={`${DEPLOY_URL}/direto?token=${item.token}`}
                                // href={`http://localhost:3000/pix?token=${item.token}`}
                                icon={<FiLink />}
                              >
                                Link para PIX
                              </MenuItem>
                              {item.status.toLowerCase() != "cancelada" && (
                                <MenuItem
                                  onClick={() => {
                                    sendEmail(item.token);
                                  }}
                                  icon={<FaArrowRight />}
                                >
                                  Enviar link por e-mail
                                </MenuItem>
                              )}
                              <MenuItem
                                onClick={() => {
                                  setOpenView(true);
                                  setItemView(item.historico);
                                }}
                                icon={<FaEye />}
                              >
                                Visualizar Histórico
                              </MenuItem>
                              <MenuItem
                                onClick={() => {
                                  setItensSelecionados(item.itens);
                                  setOpenItens(true);
                                }}
                                icon={<FaListUl />}
                              >
                                Visualizar os itens da venda
                              </MenuItem>
                              {item.status.toLowerCase() != "cancelada" &&
                                item.status.toLowerCase() != "sucesso" &&
                                item.status.toLowerCase() != "pago" && (
                                  <MenuItem
                                    onClick={() => {
                                      setIsOpen(true);
                                      setIdDelete(item.id);
                                    }}
                                    icon={<FaTrash />}
                                  >
                                    Cancelar Pix Direto
                                  </MenuItem>
                                )}
                            </MenuList>
                          </Menu>
                        </Td>
                      </Tr>
                    );
                  })}
              </Tbody>
            </Table>
          </TableContainer>
          <Flex width={"100%"} justifyContent="center" mt={8}>
            <Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              pages={pages}
              pageSize={pageSize}
            />
            <Select
              value={pageSize}
              onChange={onChangeSize}
              size="sm"
              ml={5}
              maxW="70px"
              borderRadius="6px"
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
            </Select>
          </Flex>
          <ModalItensVendaDigitada
            isOpen={openItens}
            setIsOpen={setOpenItens}
            itens={itensSelecionados}
          />
          <DeletePixDireto
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            id={idDelete}
            getLista={getLista}
          />
          <DetailsPixDireto
            isOpen={openView}
            setIsOpen={setOpenView}
            item={itemView}
          />
        </Flex>
      )}
    </>
  );
}
